<!--<as-split direction="horizontal">-->
<!--  <as-split-area [size]="40">-->
<!--    <app-document-type-list (mySelected)="list_onSelected($event)"></app-document-type-list>-->
<!--  </as-split-area>-->
<!--  <as-split-area [size]="60">-->
<!--    <app-document-type-details [modelId]="selectedId$ | async"></app-document-type-details>-->
<!--  </as-split-area>-->
<!--</as-split>-->

<kendo-splitter>
  <kendo-splitter-pane [scrollable]='false'>
    <app-document-type-list (mySelected)='list_onSelected($event)'></app-document-type-list>
  </kendo-splitter-pane>

  <kendo-splitter-pane [collapsible]='true' [scrollable]='false' size='50%'>
    <app-document-type-details [modelId]='selectedId$ | async'></app-document-type-details>
  </kendo-splitter-pane>
</kendo-splitter>
